import React from "react"
import Head from "next/head"
import { NextSeo } from "next-seo"

import HowItWorks from "~/components/HowItWorks"
import DesktopContainer from "~/components/DesktopContainer"
import Background from "~/components/HowItWorks/Background"
import Header from "~/components/dashboard/Layout/Header/OldAppHeader"
import Footer from "~/components/dashboard/Layout/Footer/BasicFooter"

const HowItWorksPage = () => {
  return (
    <>
      <NextSeo
        title="How WinIt Works | WinIt"
        description="Learn how WinIt helps you fight parking and traffic tickets in just a few easy steps. Discover how we save you time and money!"
        canonical="https://www.appwinit.com/how-it-works"
        additionalMetaTags={[
          {
            property: "description",
            content:
              "Learn how WinIt helps you fight parking and traffic tickets in just a few easy steps. Discover how we save you time and money!",
          },
        ]}
      />
      <Head>
        <title>How WinIt Works</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
      </Head>
      <Header />
      <Background>
        <DesktopContainer fullHeight>
          <HowItWorks />
        </DesktopContainer>
      </Background>
      <Footer />
    </>
  )
}

export default HowItWorksPage
